import { Giudizio, Preferenza, ScuolaTag } from ".";

export class ScenariBanner {
    preferenza?: Preferenza;
    scenari?: Array<ScuolaTag>;
    giudizio?: Giudizio;
    scuolaSuperiore?: string;
}

